import React, { SVGProps } from 'react'

export const IconEye2Blocked = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 20 20" fill="none" {...props}>
      <g clipPath="url(#clip0_1969_11903)">
        <path
          d="M8.24998 3.53303C8.82359 3.39876 9.41087 3.33164 9.99998 3.33303C15.8333 3.33303 19.1666 9.9997 19.1666 9.9997C18.6608 10.946 18.0575 11.837 17.3666 12.658M11.7666 11.7664C11.5378 12.012 11.2618 12.209 10.9551 12.3456C10.6484 12.4823 10.3174 12.5557 9.98172 12.5617C9.64604 12.5676 9.31261 12.5058 9.00132 12.3801C8.69003 12.2544 8.40725 12.0672 8.16985 11.8298C7.93245 11.5924 7.74531 11.3096 7.61957 10.9984C7.49383 10.6871 7.43208 10.3536 7.43801 10.018C7.44393 9.68228 7.5174 9.35123 7.65404 9.04457C7.79068 8.7379 7.98769 8.4619 8.23331 8.23303M14.95 14.9497C13.5255 16.0355 11.7909 16.6371 9.99998 16.6664C4.16665 16.6664 0.833313 9.9997 0.833313 9.9997C1.86989 8.06794 3.30759 6.3802 5.04998 5.0497L14.95 14.9497Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.833313 0.833008L19.1666 19.1663"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1969_11903">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
